import React, { useEffect, useState } from 'react';
import '../../App.css';
import './UserManagement.css';
import '../validate.css';
import axios from 'axios';
import Multiselect from "multiselect-react-dropdown";
import { API_URL } from '../environment';
import withNavigation from './../withNavigation';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 


class UserManagement extends React.Component {
 
  

  state = {
    agents: [],
    bettingShop: [],
    name: '',
    username: '',
    phoneNumber: undefined,
    email: '',
    password: '',
    bettingShopsDD: [],
    editAgentId: '',
    isEditing: false,
    isAgent: false,
    role: '',
    roles: [
      {id: 'AGENT', name: 'AGENT'},
      {id: 'CASHIER', name: 'CASHIER'},
    ],
    usersNumber: 0,
  }

  multiRef;

  constructor(props) {
    super(props);

    this.multiRef = React.createRef();   // 🔑 keep a handle on the widget
  }

  notify = (text = 'Text', type = 'success') => {
    toast[type](text, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 7000,
    });
  };
  

  onEditAgent = async() => {
    const { name, username, role, bettingShop, phoneNumber, email } = this.state;

    // Collect the “truthy” status of every required field
    const missing = [];
    if (!name)        missing.push('Name');
    if (!username)    missing.push('Username');
    if (!role)        missing.push('Role');
    if (!bettingShop || (bettingShop?.length === 0)) missing.push('Betting Shop');
    if (!phoneNumber) missing.push('Phone Number');
    if (!email)       missing.push('Email');

    if (missing.length) {
      // Join with commas and a space → "name, password, role"
      const requiredFieldsMissed = missing.join(', ');
      this.notify(`Please fill missed fields: ${requiredFieldsMissed}`, 'warning');
      return;
    }

    // keep just the digits (drops parentheses, dots, etc.)
    const phoneParsed = this.state.phoneNumber.replace(/\D/g, "");

    let updateObj = { id: this.state.editAgentId, name: this.state.name, username: this.state.username,
        email: this.state.email, phoneNumber: phoneParsed,
        bettingShops: this.state.bettingShop, role: this.state.role };
    if (this.state.password) {
      updateObj.password = this.state.password;
    }
    const response = await axios.put(`${API_URL}/agents`, updateObj);
    console.log('edit response', response);
    this.onClearFields();
    await this.refreshAgents();
  };

  navigateToPage = (page) => {
    this.props.navigate(page);    
  }

  onClearFields = () => {
    this.setState({
      name: '',
      username: '',
      bettingShop: '',
      phoneNumber: '',
      email: '',
      password: '',
      role: '',
      editAgentId: '',
      isEditing: false,
      isAgent: false,
    });
  };

  async refreshAgents() {
    try {
      const storedUser = JSON.parse(localStorage.getItem("sun_user"));
      const isAdmin = storedUser && storedUser.role === 'ADMIN';
      const betShopRest = localStorage.getItem('sun_bettingShopId');

      const params = {};
      if (!isAdmin) {
        // !TODO: verify $in cond for multiple betting shops
        params.bettingShops = betShopRest;
      }
      const response = await axios.get(`${API_URL}/agents`, {params});

      let formattedData = (response.data || []).reverse();
      const nowTime = new Date().getTime();
      const ONLINE_STATUS = 'online';
      const OFFINE_STATUS = 'offline';

      formattedData = formattedData.map( o => {
        const date = new Date(o.createdAt);

        const formattedTime = new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        }).format(date);

        o.createdAtF = formattedTime;

        const lastActivity = o.lastActivityTime || null;
        const MINS_5 = 1000 * 60 * 5;

        if (lastActivity) {
          const timeOffset = nowTime - new Date(lastActivity).getTime();
          if (timeOffset <= MINS_5) {
            o.onlineStatus = ONLINE_STATUS;
          } else {
            o.onlineStatus = OFFINE_STATUS;
          }
        } else {
          o.onlineStatus = OFFINE_STATUS;
        }

        return o;
      } );

      const shopListParams = {};
      if (!isAdmin) {
        shopListParams._id = betShopRest;
      }

      const usersNumber = formattedData.length;
      const responseBs = await axios.get(`${API_URL}/bettingshops`, {params: shopListParams});
      const bettingShopsData = (responseBs && responseBs.data) || [];
      this.setState({agents: formattedData, bettingShopsDD: bettingShopsData, usersNumber});

      // setData(formattedData); // Update state with fetched data
      // setLoading(false); // Set loading to false
    } catch (err) {
      console.log(err);
      // setError(err.message); // Update state with error message
      // setLoading(false); // Set loading to false
    }
  }

  async componentDidMount() {
    document.body.classList.add('validate-active');
    const storedUser = JSON.parse(localStorage.getItem("sun_user"));
    const isAdmin = storedUser && storedUser.role === 'ADMIN';
    const isAgent = storedUser && storedUser.role === 'AGENT';
    if (isAdmin) {
      this.setState({roles:[
        {id: 'ADMIN', name: 'ADMIN'},
        {id: 'AGENT', name: 'AGENT'},
        {id: 'AUDITOR', name: 'AUDITOR'},
        {id: 'CASHIER', name: 'CASHIER'},
      ]});
    } else if (isAgent) {
      this.setState({
        isAgent: true,
      });
    }

    await this.refreshAgents();
  }

  componentWillUnmount() { 
    clearTimeout(this.timer);
  }


  // Handle changes to the inputs
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }); // Update the corresponding state
  };

  // Pass the state values to the onCreateUser function
  handleCreateAgent = () => {
    const { name, username, password, role, bettingShop, phoneNumber, email } = this.state;

    // Collect the “truthy” status of every required field
    const missing = [];

    if (!name)        missing.push('Name');
    if (!username)    missing.push('Username');
    if (!role)        missing.push('Role');
    if (!password)    missing.push('Password');
    if (!bettingShop || (bettingShop?.length === 0)) missing.push('Betting Shop');
    if (!phoneNumber) missing.push('Phone Number');
    if (!email)       missing.push('Email');

    if (missing.length) {
      // Join with commas and a space → "name, password, role"
      const requiredFieldsMissed = missing.join(', ');
      this.notify(`Please fill missed fields: ${requiredFieldsMissed}`, 'warning');
      return;
    }

    // keep just the digits (drops parentheses, dots, etc.)
    const phoneParsed = phoneNumber.replace(/\D/g, "");
    this.onCreateUser(name, username, password, role,  bettingShop, phoneParsed, email); // Call the function with input values
  };

  onCreateUser = async(name, username, password, role, bettingShop, phoneNumber, email) => {
    console.log("Creating betting shop with details:");
    console.log("Name:", name);
    console.log("Address:", username);

    const bettingShopFiltered = bettingShop; // role === 'ADMIN' ? '' : bettingShop; 
    console.log("BettingShopId", bettingShop);
    try {
      const response = await axios.post(`${API_URL}/agents`, {name, username, password, role, bettingShopIds: bettingShopFiltered, phoneNumber, email});
      console.log('create response', response);
    } catch (e) {
      const isDuplicateUsername = e?.response?.data?.error?.includes('duplicate key error')
      if (isDuplicateUsername) {
        this.notify('Duplicated Username', 'error');
      }
      return;
    }
    this.onClearFields();
    await this.refreshAgents();
    const userId = localStorage.getItem("sun_userId");
    await axios.post(`${API_URL}/logaction`, {
      action: 'create_user',
      data: username,
      user: userId,
    });
  };

  handleEdit = async(id) => {
    console.log("Editing agent with ID:", id);
    // Logic to handle editing the agent
    // For example, navigate to an edit form or pre-fill inputs with the agent's data

    // load data to the right popup
    const currentAgent = this.state.agents.find(o => o._id === id);
    const bettingShops = currentAgent?.bettingShops?.map(o => o._id);

    this.setState({
      editAgentId: currentAgent._id,
      name: currentAgent.name,
      username: currentAgent.username,
      email: currentAgent.email,
      phoneNumber: currentAgent.phoneNumber,
      bettingShop: bettingShops,
      role: currentAgent.role,
      password: '',
      isEditing: true,
    });

    // const userId = localStorage.getItem("sun_userId");

    // await axios.post(`${API_URL}/logaction`, {
    //   action: 'edit_user',
    //   data: currentAgent.username,
    //   user: userId,
    // });
  };
  
  handleDelete = async (id) => {
    console.log("Deleting agent with ID:", id);

    // PUT request with set active false
    try {
      // API call to delete the agent
      const response = await axios.delete(`${API_URL}/agents`, {params: { id }},);
      
      console.log("Delete response:", response);
  
      // Refresh the list of agents after deletion
      await this.refreshAgents();
    } catch (error) {
      console.error("Error deleting agent:", error);
    }
  };

  /* Multiselect gives you the full array of selected option objects.
    Convert them to an array of _id’s and keep in state.              */
  handleShopSelect = (selectedList /* all selected */, _item) => {

    this.setState({ bettingShop: selectedList.map(s => s._id) });
  };

  handleShopRemove = (selectedList /* after remove */, _item) => {
    this.setState({ bettingShop: selectedList.map(s => s._id) });
  };

  handleSelectAllSh = () => {
    const { bettingShopsDD } = this.state;
    // 1. update our own state
    this.setState({ bettingShop: bettingShopsDD.map(s => s._id) });
    // 2. tell the widget (avoids waiting for re-render)
    // void this.multiRef.current?.selectAll();     // API from the library
  };

  handleClearAllSh = () => {
    this.setState({ bettingShop: [] });
    // void this.multiRef.current?.resetSelectedValues();  // library helper
  };

  render() {
      const { bettingShopsDD, bettingShop } = this.state;

      /* Multiselect needs the *full objects* in `selectedValues`, so
        rebuild that array from the IDs you keep in state.              */
      const preselected = bettingShopsDD.filter(s =>
        bettingShop.includes(s._id)
      );

      return <>
      <ToastContainer
        position="top-center"
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
      />
      <div className="validate">
        <div className="validate-left">
          <div className="spin-border dashbord-border">
            <div className="spin-light spin-light-top">
              <div className="spin-light-container">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                ))}
              </div>
            </div>
            <div className="spin-number">
              <div className="spin-number__text">
                <span className="spin-number__text-big">USERS ({this.state.usersNumber})</span> 
              </div> 
            </div>
            <div className="spin-light spin-light-bottom">
              <div className="spin-light-container">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                ))}
              </div>
            </div>
          </div>

          <div className="table-maket">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Betting Shop</th>
                <th>Role</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
            {this.state.agents.map((item) => {
                return (
                  <tr key={item._id}>
                    <td>
                    {item.name}
                    </td>
                    <td>
                    {item.username}
                    </td>
                    <td>
                    {item.bettingShops?.map(o => o.name)?.join(', ')}
                    </td>
                    <td>
                    {item.role}
                    </td>
                    <td className={
                      item.onlineStatus === 'online' ? 'status-online' :
                      item.onlineStatus === 'offline' ? 'status-offline' :
                      ''
                    }>
                      {item.onlineStatus}
                    </td>
                    <td>
                    {item.createdAtF}
                    </td>
                    <td style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    {(!(this.state.isAgent && item.role === 'ADMIN')) && <button className="wrap-validate_item wrap-validate_item-mini" onClick={() => this.handleEdit(item._id)}>Edit</button>}
                    {(!(this.state.isAgent && item.role === 'ADMIN')) && <button className="wrap-validate_item wrap-validate_item-mini" onClick={() => this.handleDelete(item._id)}>Delete</button>}
                    </td>
                  </tr>
                );
              })}

            </tbody>
          </table>
          </div>
        </div>
        <div className="validate-right">
          <button className="return-menu btn-yellow"
            onClick={() => this.navigateToPage('/dashboard')}>RETURN TO MAIN MENU</button>
           <div className="betting-form">
            {/* Hidden dummy input to trick autofill */}
            <input type="text" style={{ display: "none" }} autoComplete="name" />
            <input className="betting-form__input betting-form__input-width" placeholder='Name'
              name="name" // Name must match the state key
              autoComplete="off"
              value={this.state.name}
              onChange={this.handleInputChange} // Handle input changes
              required
            />

            {/* Hidden dummy input to trick autofill */}
            <input type="text" style={{ display: "none" }} autoComplete="username" />
            <input className="betting-form__input betting-form__input-width" placeholder='Username'
              name="username" // Name must match the state key
              value={this.state.username}
              autoComplete="off"
              onChange={this.handleInputChange} // Handle input changes
              required          
            />

            {/* Hidden dummy input to trick autofill */}
            <input type="text" style={{ display: "none" }} autoComplete="email" />
            <input className="betting-form__input betting-form__input-width" placeholder='Email'
              name="email" // Name must match the state key
              value={this.state.email}
              autoComplete="off"
              onChange={this.handleInputChange} // Handle input changes
              required           
            />

            {/* Hidden dummy input to trick autofill */}
            <input type="text" style={{ display: "none" }} autoComplete="phoneNumber" />
            <input className="betting-form__input betting-form__input-width" placeholder='Phone Number'
              name="phoneNumber" // Name must match the state key
              value={this.state.phoneNumber}
              autoComplete="off"
              onChange={this.handleInputChange} // Handle input changes
              required
            />

            {/* Hidden dummy password input */}
            <input type="password" style={{ display: "none" }} autoComplete="new-password" />
            <input className="betting-form__input betting-form__input-width" placeholder='Password'
              name="password" // Name must match the state key
              type='password'
              autoComplete="new-password"
              value={this.state.password}
              onChange={this.handleInputChange} // Handle input changes
              required
            />
            <select
              className="betting-form__input betting-form__input-width"
              name="role"
              value={this.state.role}
              onChange={this.handleInputChange}
            >
              <option value="" disabled>
                Select Role
              </option>
              {this.state.roles.map((role) => (
                <option key={role._id} value={role._id}>
                  {role.name}
                </option>
              ))}
            </select>
            <div className="betshop-wrap">
              <div className="um-edit-mode-wrap betwrap-btn">
                  <button className="betting-form__btn btn-blue" onClick={this.handleSelectAllSh}>
                    Select All
                  </button>
                  <button className="betting-form__btn btn-blue" onClick={this.handleClearAllSh}>
                    Clear All
                  </button>
                </div>
              <Multiselect
                ref={this.multiRef}
                className="betting-form__input-multiselect betting-form-mult"
                options={bettingShopsDD}      // full list
                selectedValues={preselected}  // those that are already chosen
                onSelect={this.handleShopSelect}
                onRemove={this.handleShopRemove}
                showCheckbox={true}
                displayValue="name"           // shows `shop.name` in the UI
                placeholder="Select Betting Shops"
                style={{
                  chips: { background: "#2d96ff" },  // feel free to theme
                  multiselectContainer: { color: "#333" }
                }}
              />
            </div>      

            <div>
              {this.state.isEditing ? (
                <div className="um-edit-mode-wrap">
                  <button className="betting-form__btn btn-blue" onClick={this.onEditAgent}>
                    Save Agent
                  </button>
                  <button className="betting-form__btn btn-blue" onClick={this.onClearFields}>
                    Cancel
                  </button>
                </div>
              ) : (
                <button className="betting-form__btn btn-blue" onClick={() => this.handleCreateAgent()}>
                  Create Agent
                </button>
              )}
            </div>

           </div>
        </div>
      </div>
      </>;
  }
}

export default withNavigation(UserManagement);
